import React from "react";

const Wave = () => {
  return (
    <div className="-mb-28 md:-mb-52 lg:-mb-96">
      <svg
        width="100%"
        height="100%"
        id="svg"
        viewBox="0 0 1440 400"
        xmlns="http://www.w3.org/2000/svg"
        className="transition duration-300 ease-in-out delay-150"
      >
        <path
          d="M 0,400 C 0,400 0,133 0,133 C 63.29783579525936,129.27825489522502 126.59567159051872,125.55650979045004 186,137 C 245.40432840948128,148.44349020954996 300.9151494331845,175.05221573342493 375,177 C 449.0848505668155,178.94778426657507 541.7437306767434,156.23462727585022 615,141 C 688.2562693232566,125.76537272414978 742.1099278598418,118.00927516317415 813,106 C 883.8900721401582,93.99072483682585 971.8165578838887,77.72827207145312 1050,88 C 1128.1834421161113,98.27172792854688 1196.6238406046032,135.0776365510134 1260,147 C 1323.3761593953968,158.9223634489866 1381.6880796976984,145.96118172449331 1440,133 C 1440,133 1440,400 1440,400 Z"
          stroke="none"
          strokeWidth="0"
          fill="#312e81"
          fill-opacity="0.53"
          className="transition-all duration-300 ease-in-out delay-150 path-0"
          transform="rotate(-180 720 200)"
        ></path>
        <path
          d="M 0,400 C 0,400 0,266 0,266 C 54.46788045345241,241.07866712469942 108.93576090690482,216.15733424939884 183,218 C 257.0642390930952,219.84266575060116 350.72483682583305,248.44933012710408 430,270 C 509.27516317416695,291.5506698728959 574.1648917897629,306.0453452421848 638,308 C 701.8351082102371,309.9546547578152 764.6155960151152,299.36928890415663 839,276 C 913.3844039848848,252.63071109584337 999.3727241497766,216.4774991411886 1058,222 C 1116.6272758502234,227.5225008588114 1147.893507385778,274.72071453108896 1207,289 C 1266.106492614222,303.27928546891104 1353.0532463071108,284.6396427344555 1440,266 C 1440,266 1440,400 1440,400 Z"
          stroke="none"
          strokeWidth="0"
          fill="#312e81"
          fill-opacity="1"
          className="transition-all duration-300 ease-in-out delay-150 path-1"
          transform="rotate(-180 720 200)"
        ></path>
      </svg>
    </div>
  );
};

export default Wave;
